import DeviceApi from '../api/DeviceApi';
import LogApi from '../api/LogApi';
import router from '../router';

import { MOBILE_DATA_YN, ONLY_WIFI_YN } from '../const';

//import store from '../store';

import { alertDialog } from './DialogHelper';

const PREFIX_APP_AGENT = process.env.APP_AGENT;

/* webview 체크 */
const isWebView = () => {
    const broswerInfo = navigator.userAgent;
    console.log(broswerInfo);
    return broswerInfo.indexOf(PREFIX_APP_AGENT) > -1 ? true : false;
};

/* 현재 앱버전 가져오기 */
const getAppVersion = () => {
    const broswerInfo = navigator.userAgent;
    return broswerInfo.substring(broswerInfo.indexOf(PREFIX_APP_AGENT + '/') + PREFIX_APP_AGENT.length + 1);
};

/* 웹뷰내의 플랫폼 가져오기 */
const getWebViewPlatform = () => {
    if (isWebView()) {
        return getPlatform();
    }
    return false;
};

const getPlatform = () => {
    const broswerInfo = navigator.userAgent || navigator.vendor || window.opera;
    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(broswerInfo)) {
        return 'window';
    }
    if (/android/i.test(broswerInfo)) {
        return 'android';
    } // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod|ipad|iphone|ipad/.test(broswerInfo) && !window.MSStream) {
        return 'ios';
    }
    return 'unknown';
};

const isTablet = () => {
    const platform = getPlatform();
    let isTablet = false;
    if (platform === 'ios') {
        const userAgent = navigator.userAgent.toLowerCase();
        isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
            userAgent
        );
    } else {
        const w = window.outerWidth;
        const h = window.outerHeight;
        if (w >= h && w >= 850) return true;
        if (w < h && h >= 850) return true;
    }

    // console.log(isTablet);
    return isTablet;
};

/* 가급적 로그인 이후에 device ready 호출을 해야 됨*/
const onDeviceReady = () => {
    const platform = getPlatform();
    const version = getAppVersion();

    const DwNotification = window.PushNotification;

    if (DwNotification) {
        const push = DwNotification.init({
            android: {
                forceShow: true,
                clearBadge: true
            },
            ios: {
                badge: true,
                clearBadge: true
            }
        });

        if (push) {
            push.on('registration', function(data) {
                const pushParam = {
                    deviceId: window.device.uuid,
                    platform,
                    registrationId: data.registrationId,
                    version,
                    model: window.device.model
                };
                //registration 모든 알림에 대해서 다 읽은 것으로 표시한다.
                DeviceApi.save(pushParam);
                console.log(pushParam);
                //배지개수는 무조건 1로 처리한다.
                //PushApi.clearBadge(pushParam).catch(e => this.$store.commit(MutationTypes.ERROR, e));
            });
            push.on('notification', data => {
                const pushData = data.additionalData;
                if (platform === 'ios') {
                    if (pushData.link && pushData.foreground && (pushData.message || data.message)) {
                        alertDialog(pushData.message || data.message);
                    }
                }
                console.log('pushData::' + JSON.stringify(pushData));
                if (pushData.link) {
                    router.push({ path: pushData.link });
                }
            });
        }
    }
};

const doLastAccess = () => {
    const param = {
        appVer: isWebView() ? getAppVersion() : process.env.VERSION,
        platform: getPlatform(),
        userAgent: navigator.userAgent
    };
    //console.log(param);
    LogApi.accessLog(param);
};

const isWifi = () => {
    if (!isWebView()) {
        return true;
    }

    const networkState = navigator.connection.type;
    const Connection = window.Connection;
    return networkState === Connection.WIFI ? true : false;
};

const isDownloadable = () => {
    if (!isWebView()) {
        return true;
    }
    const onlyWifiYn = window.localStorage.getItem(ONLY_WIFI_YN);
    const networkState = navigator.connection.type;
    const Connection = window.Connection;
    if (networkState !== Connection.NONE) {
        if (onlyWifiYn === 'Y') {
            if (!isWifi()) return false;
        }
        return true;
    } else return false;
};

const isPlayable = () => {
    if (!isWebView()) {
        return true;
    }
    const mobileDataYn = window.localStorage.getItem(MOBILE_DATA_YN);
    const networkState = navigator.connection.type;
    const Connection = window.Connection;
    if (networkState !== Connection.NONE) {
        if (mobileDataYn === 'N') {
            if (!isWifi()) return false;
        }
        return true;
    } else return false;
};

const isRooti = () => {
    if (!isWebView()) {
        return true;
    }
    window.IRoot.isRooted(res => {
        if (res) {
            window.cordova.plugins.exit();
        }
    });
};

export default {
    isWebView,
    getAppVersion,
    getWebViewPlatform,
    getPlatform,
    onDeviceReady,
    doLastAccess,
    isWifi,
    isDownloadable,
    isPlayable,
    isRooti,
    isTablet
};
